import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { HasPermissionModule } from './../../shared/directives/has-permissions/has-permissions.module';

import { LinkTabsComponent } from './link-tabs.component';

@NgModule({
  declarations: [LinkTabsComponent],
  imports: [CommonModule, RouterModule, HasPermissionModule],
  exports: [LinkTabsComponent]
})
export class LinkTabsModule {}
